module.exports = __webpack_public_path__ + "static/media/favicon.93724f10.ico";